module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Settings_Import_Export_Breadcrumb')))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "view__panel"
  }, [_c('submenu'), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Settings_Import_Export_DownloadExemple",
      "float": "right",
      "withBorder": true
    },
    on: {
      "click": _vm.downloadExemple
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "view__text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.L.localize('ImportExport_EmptyValue'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.L.localize('ImportExport_AmendValue'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "view__text"
  }, [_vm._l((_vm.messages), function(message) {
    return _c('Message', {
      attrs: {
        "message": message
      }
    })
  }), _vm._v(" "), (!_vm.cannotProceed) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.L.localize('ImportExport_Confirm')))]), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "ImportExport_Confirm_Btn"
    },
    on: {
      "click": _vm.proceed
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "ImportExport_Ignore_Btn"
    },
    on: {
      "click": _vm.cancel
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.messages.length === 0) ? _c('div', [_c('fieldset', {
    staticClass: "form__field"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "fileUpload"
    }
  }, [_vm._v(_vm._s(_vm.L.localize('Settings_Import_Export_SpecifyFileImport')))]), _vm._v(" "), _c('input', {
    ref: "fileUpload",
    staticClass: "form__input",
    attrs: {
      "type": "file",
      "accept": ".csv"
    }
  })]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "label": "Label_UpdateOnly",
      "notice": "Label_UpdateOnly_Notice",
      "acc": "isUpdateOnly"
    },
    model: {
      value: (_vm.isUpdateOnly),
      callback: function($$v) {
        _vm.isUpdateOnly = $$v
      },
      expression: "isUpdateOnly"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Settings_Import_Export_ImportUsers"
    },
    on: {
      "click": _vm.importFile
    }
  })], 1) : _vm._e()], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ab0b1ad!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/groups/Import.vue
// module id = 714
// module chunks = 1